<script setup lang="ts">
import { BoulderModel } from '../../../core/boulder_model';
import { getApplicationInstance } from '../../../core/app';
import { useBoulderModel } from '../composables/app';
import { computed } from 'vue';

const props = defineProps<{ boulder: BoulderModel }>();
const boulder = computed(() => props.boulder);
const linesCaption = computed(() => {
    const linesCount = boulder.value.lines?.length || 0;
    if (linesCount === 0) {
        return "No lines";
    }
    else if (linesCount === 1) {
        return "1 line";
    }
    else {
        return `${linesCount} lines`;
    }
});

const selectedBoulder = useBoulderModel();
const selected = computed(() => {
    const result = selectedBoulder.value == props.boulder;
    return result;
});
</script>

<template>
    <button @click="getApplicationInstance().boulder = props.boulder" class="thumbnail-container"
        :class="{ 'thumbnail-selected': selected }">
        <img class="thumbnail" :src="boulder.thumbnail || '/thumbnails/default.png'" decoding="async"
            loading="lazy"></img>
        <p class="thumbnail-name">{{ boulder.name }}</p>
        <div class="thumbnail-description-container">
            <p class="thumbnail-description boulder-thumbnail-lines">{{ linesCaption }}</p>
        </div>
    </button>
</template>
